module.exports = __webpack_public_path__ + "img/session-expired-icon.d04852c7.png";